import { get, getPaginated, patch } from '@/api/base'

const companiesApi = {
  get: async companyUuid => {
    const response = await get({
      path: `companies/${companyUuid}`,
    })
    return response.data?.company
  },
  getAll: async () => {
    const response = await getPaginated({ path: 'companies', valuePath: 'companies' })
    return response.success ? response.values : []
  },
  getFromSearch: async text => {
    const response = await get({
      path: 'companies',
      params: { search_phrase: text },
    })
    return response.success ? response.data.companies : []
  },
  update: async (companyUuid, params) => {
    return await patch({
      path: `companies/${companyUuid}`,
      params,
    })
  },
}

export default companiesApi
